/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/

/* eslint-disable camelcase */
import logger from '../logger/logger';
export var setPageId = function setPageId(id) {
  if (id && window.utag && window.utag_data) {
    logger.info('Setting Tealium pageId', id);
    window.mwfGlobals.pageId = id;
    window.utag_data['page_id'] = id;
    window.utag.view(window.utag_data);
  }
};
export var getPageId = function getPageId(tealium) {
  return tealium.pageId + (tealium.pageSubId ? " - ".concat(tealium.pageSubId) : '');
};
export var setUtagSearchTerm = function setUtagSearchTerm(searchTerm) {
  if (window.utag && window.utag_data) {
    logger.info('Setting utag search term', searchTerm);
    window.utag_data['search_term'] = searchTerm;
    window.utag.view(window.utag_data);
  }
};